"use strict";
/**
 * Pair builder UI rendering helpers
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderPairBuilder = renderPairBuilder;
exports.renderMonitorPairs = renderMonitorPairs;
exports.getPairBuilderRenderState = getPairBuilderRenderState;
function renderPairBuilder(options) {
    renderList("kalshi-market-list", options.kalshiItems, options.selectedKalshi, options.search, options.kalshiLoading, (item) => item.ticker, (item) => item.title, (item) => item.eventTitle, options.onSelectKalshi);
    renderList("pmus-market-list", options.pmItems, options.selectedPm, options.search, options.pmLoading, (item) => item.slug, (item) => item.question, (item) => item.eventTitle, options.onSelectPm);
    const selectedKalshi = document.getElementById("pair-builder-selected-kalshi");
    const selectedPm = document.getElementById("pair-builder-selected-pm");
    const addBtn = document.getElementById("pair-builder-add-btn");
    if (selectedKalshi) {
        selectedKalshi.textContent = options.selectedKalshi ?? "None";
    }
    if (selectedPm) {
        selectedPm.textContent = options.selectedPm ?? "None";
    }
    if (addBtn) {
        addBtn.disabled = !options.selectedKalshi || !options.selectedPm;
    }
}
function renderMonitorPairs(pairs, containerId) {
    const container = document.getElementById(containerId);
    if (!container) {
        return;
    }
    if (!pairs.length) {
        container.innerHTML = '<p class="muted">No pairs tracked yet.</p>';
        return;
    }
    container.innerHTML = pairs
        .map((pair) => `<div class=\"market-option\">
					<div class=\"market-option-title\">${pair.kalshiTicker} ↔ ${pair.pmSlug}</div>
					<button
						class=\"btn btn-small\"
						data-remove-pair
						data-kalshi-ticker=\"${pair.kalshiTicker}\"
						data-pm-slug=\"${pair.pmSlug}\"
					>
						Remove
					</button>
				</div>`)
        .join("");
}
function renderList(containerId, items, selectedKey, search, isLoading, getKey, getTitle, getSubtitle, onSelect) {
    const container = document.getElementById(containerId);
    if (!container) {
        return;
    }
    if (isLoading) {
        container.innerHTML = '<p class="muted">Loading markets...</p>';
        return;
    }
    const normalized = search.trim().toLowerCase();
    const filtered = normalized
        ? items.filter((item) => {
            const title = getTitle(item).toLowerCase();
            const key = getKey(item).toLowerCase();
            const subtitle = getSubtitle(item)?.toLowerCase() ?? "";
            return (title.includes(normalized) ||
                key.includes(normalized) ||
                subtitle.includes(normalized));
        })
        : items;
    if (!filtered.length) {
        container.innerHTML = '<p class="muted">No results yet.</p>';
        return;
    }
    container.innerHTML = filtered
        .map((item) => {
        const key = getKey(item);
        const title = getTitle(item);
        const subtitle = getSubtitle(item);
        const selectedClass = selectedKey === key ? "selected" : "";
        return `
				<button class=\"market-option ${selectedClass}\" data-key=\"${key}\">
					<div class=\"market-option-title\">${title}</div>
					${subtitle ? `<div class=\"market-option-subtitle\">${subtitle}</div>` : ""}
					<div class=\"market-option-subtitle\">${key}</div>
				</button>
			`;
    })
        .join("");
    container
        .querySelectorAll(".market-option")
        .forEach((btn) => {
        btn.addEventListener("click", () => {
            const key = btn.dataset.key;
            if (key) {
                onSelect(key);
            }
        });
    });
}
function getPairBuilderRenderState(state) {
    return {
        kalshiItems: state.pairBuilder.kalshiMarkets,
        pmItems: state.pairBuilder.pmUsMarkets,
        selectedKalshi: state.pairBuilder.selectedKalshiTicker,
        selectedPm: state.pairBuilder.selectedPmSlug,
        search: state.pairBuilder.search,
        kalshiLoading: state.pairBuilder.kalshiLoading,
        pmLoading: state.pairBuilder.pmLoading,
    };
}
